import React, {Fragment} from 'react';

import PlayerCard from "../../../ui/tabs/scouting_reports_tab_base/PlayerCard";
import PlayerReport from "./components/ScoutingPlayerReport";
import ScoutingReportsTab from "../full_profile/tabs/ScoutingReportsTab";
import SelectButtons from "../../../ui/select/SelectButtons";
import VerticalTabs from "../../../ui/tabs/VerticalTabs";
import annFloresAvatar from "../../../../assets/img/demo/ann-flores-avatar.png";
import darrellMckinneyAvatar from "../../../../assets/img/demo/darrell-mckinney-avatar.png";
import {Button, Col, Form, InputGroup, Row, Toast} from "react-bootstrap";
import Discussion from "./components/Discussion";
import Participants from "../../../ui/general/participants/Participants";

import avatarImg from "../../../../assets/img/demo/player-avatar-1.png";
import check from "../../../../assets/svg/actions/icn-check-blue-24px.svg";
import InlineSVG from "react-inlinesvg";
import searchIcon from "../../../../assets/svg/actions/icn-search.svg";

const player1 = {
    name: 'Dustin Williamson',
    teamName: 'CF, RAMF, RWF | Real Madrid',
    score: 87,
    datetime: '31 Jan 2019',
    avatar: annFloresAvatar,
};

const player2 = {
    name: 'Philip Mccoy',
    teamName: 'CF, RAMF, RWF | Chelsea Football Club',
    score: 87,
    datetime: '30 Jul 2018',
    avatar: darrellMckinneyAvatar,
};

const items = Array.from(Array(10).keys()).map(i => (i % 2 === 1 ? player1 : player2));

class SharedScoutings extends ScoutingReportsTab {

    state = {
        commentsOrParticipants: 'comments',
        new_participants: Array.from(Array(25).keys())
            .map((item, index) => ({
                key: index,
                avatar: avatarImg,
                name: 'Calvin Cooper',
                info: 'Scout | Canberry Football Club',
                selected: false,
            })),
        participants: [],
        participants_add: false,
        participants_toast: '',
    }

    selectButtonsOptions = [
        {value: 'reports-i-shared', label: 'Reports I Shared'},
        {value: 'shared-with-me', label: 'Shared With Me'},
    ];

    commentsOrParticipantsOptions = [
        {value: 'comments', label: 'Comments'},
        {value: 'participants', label: 'Participants'}
    ];

    /**
     * Renders the content of the page.
     * @returns {React.ReactNode} The page content.
     */
    renderContent = () => {
        const renderedItems = this.renderTabs(items);

        return (
            <VerticalTabs id="scouting-reports-tab" items={renderedItems} search={true} searchPlaceholder="Search Player" renderExtraTabsController={this.renderExtraTabsController}/>
        );
    };

    renderPlayersCard = (player) => {
        return <SharedScoutings.PlayerCard {...player}/>
    };

    renderPlayerContent = (player) => {
        return (
            <Row className="flex-grow-1 no-gutters">
                <Col xs={8}>
                    {this.renderReportSection(player)}
                </Col>
                <Col xs={4}>
                    {this.renderChatSection(player)}
                </Col>
            </Row>
        );
    };

    renderReportSection = (player) => {
        return (<SharedScoutings.PlayerReport {...player}/>);
    };

    renderChatSection = (player) => {
        return (
            <div className="chat-section">
                {this.SelectOrParticipantsSearch()}
                {this.commentsOrParticipants()}
            </div>
        )
    };

    commentsOrParticipantsChange = (e, option, name) => {
        this.setState({
            commentsOrParticipants: option.value
        })
    }

    SelectOrParticipantsSearch = () => {
        return this.state.participants_add == false ? (
            <div className="toggle-select">
                <SelectButtons size="sm" options={this.commentsOrParticipantsOptions} onSelect={this.commentsOrParticipantsChange} defaultValue={this.commentsOrParticipantsOptions[0]?.value}/>
            </div>
        ) : (
            <div className="search">
                <InputGroup className="input-group-white-lg">
                    <Form.Control name="text" placeholder="Search Scouts to add" className="input input-white input-lg"/>
                    <InputGroup.Append>
                        <InputGroup.Text>
                            <i><InlineSVG src={searchIcon}/></i>
                        </InputGroup.Text>
                    </InputGroup.Append>
                </InputGroup>
            </div>
        );
    }

    commentsOrParticipants = () => {
        return this.state.commentsOrParticipants == 'comments' ? (
            <Discussion/>
        ) : this.manageParticipants();
    }

    toastShow = () => {
        this.setState({
            participants_toast: '',
        })
    }

    manageParticipants = () => {
        return (
            <div className="participants-wrapper">
                <Participants className={this.state.participants_add ? "new-participants" : null } data={this.state.participants_add ? this.state.new_participants : this.state.participants} hasClose={this.state.participants_add == false} hasToggleIcon={this.state.participants_add == true} itemToggleSelected={this.toggleSelected} deleteItem={this.deleteItem} activeIcon={check} inactiveIcon={null}/>
                <div className="btn-wrapper">
                    { this.state.participants_toast ? (
                        <Toast onClose={() => this.toastShow(false)} show={this.state.participants_toast ? true : false} delay={3000} autohide>
                            <Toast.Body>{this.state.participants_toast}</Toast.Body>
                        </Toast>
                    ) : null }
                    <Button variant="primary" className="btn-block btn-lg" onClick={this.addParticipant}>{ this.state.participants_add ? "Add Selected Participants" : "Add More Participants" }</Button>
                </div>
            </div>
        )
    }

    addParticipant = () => {
        var {participants_add} = this.state;
        if(participants_add) {
            // submit new participants

            var selectedParticipants = this.state.new_participants.filter((item) => { return item.selected == true });
            var clear_new_participants = this.state.new_participants.map((item) => {
                item.selected = false
                return item;
            });

            this.setState({
               participants: [...this.state.participants, ...selectedParticipants],
               new_participants: clear_new_participants,
               participants_toast: `${selectedParticipants.length} Participants Added`,
               participants_add: false,
           })
        } else {
            // switch to add new participants
            this.setState({
                participants_toast: '',
                participants_add: true,
            })
        }
    }

    searchableFields = (player) => {
        return [player.name, player.teamName];
    };

    renderSwitchType = () => {
        return (
            <div className="player-switch">
                <SelectButtons size="sm" options={this.selectButtonsOptions} defaultValue={this.selectButtonsOptions[0]?.value}/>
            </div>
        )
    }

    toggleSelected = (index, active) => {

        var new_participants = this.state.new_participants.map((item) => {
            if(item.key == index)
                item.selected = active
            return item;
        });

        this.setState({
            new_participants: new_participants
        })
    }

    deleteItem = (index) => {
        var participants = this.state.participants.filter((item) => item.key != index);
        this.setState({
            participants: participants
        })
    }

    renderExtraTabsController = {
        topComponent: this.renderSwitchType,
    }
}

SharedScoutings.PlayerCard = PlayerCard;
SharedScoutings.PlayerReport = PlayerReport;

export default SharedScoutings;
